import React from 'react';
import { useTranslation } from 'react-i18next';
import { DropDown } from '@/components/design-system/molecules/dropdown';
import { useGetOwners } from '../../hooks/use-get-owners';
import { useStatsFiltersContext } from '../../hooks/use-stats-filters';

const StatsOwnerSelectionDropDown = () => {
  const { selectedOwner, setSelectedOwner } = useStatsFiltersContext();
  const { t } = useTranslation();
  const { data: ownersData } = useGetOwners();

  return (
    <DropDown
      placeholder={t('js.features.admin.stats.dashboard.property_manager_selection.placeholder')}
      className="z-50 w-[200px]"
      showLabel
      label={t('js.features.admin.stats.dashboard.owner_selection.label')}
      value={selectedOwner}
      onChange={setSelectedOwner}
      {...(selectedOwner && {
        displayValue: selectedOwner.name
      })}
    >
      <DropDown.DropDownOptions>
        <DropDown.DropDownOption key="all" value={undefined}></DropDown.DropDownOption>
        {ownersData?.data?.map((owner) => (
          <DropDown.DropDownOption key={owner.id} value={owner}>
            <DropDown.DropDownOptionDefaultContent className="font-['sofia-pro'] text-sm font-normal leading-[21px] text-[#212529]">
              {owner.name}
            </DropDown.DropDownOptionDefaultContent>
          </DropDown.DropDownOption>
        ))}
      </DropDown.DropDownOptions>
    </DropDown>
  );
};

export { StatsOwnerSelectionDropDown };
